import { reBuildTypeConstants } from './constants'

const initialState =
	{
		list	    	: [],
		isSending	    : false,
		error		    : null
	}

export default function (state = initialState, action){
	switch (action.type){
		case reBuildTypeConstants.GetBuildTypes.REQUEST:
			return {
				...state,
				isSending : true
			}
		case reBuildTypeConstants.GetBuildTypes.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case reBuildTypeConstants.GetBuildTypes.SUCCESS:
			return {
				...state,
				isSending : false,
				list : action.payload.result
			}
		case reBuildTypeConstants.ClearBuildTypes:
			return {
				...state,
				list : []
			}
		default:
			return state
	}
}